// src/auth/syncLogout.js
import router from '@/router'
import { resetAuthState } from './index'
import { clearTokens } from '@/utils/token'

const LOGOUT_SYNC_KEY = 'logout_sync'

export function setupLogoutSync() {
    window.addEventListener('storage', (event) => {
        if (event.key === LOGOUT_SYNC_KEY) {
            // 這個分頁不是觸發 clearTokens 的分頁，但要跟著一起登出
            resetAuthState()
            clearTokens() // 確保本分頁 localStorage 也乾淨（多呼叫一次沒關係）

            // 視需求導向 Login 或 Home
            const name = router.currentRoute.value.name
            if (name !== 'Login' && name !== 'Home') {
                router.push({ name: 'Home' })
            }
        }
    })
}
